import React, { Component } from 'react';
import Icofont from 'react-icofont';
import PropTypes from "prop-types";
import ScrollAnimation from 'react-animate-on-scroll';

class Services extends Component {
  render() {
      //Service loop start
      const servicedata = this.props.servicesData.map((service, index) => (
        <div className="col-md-6 col-lg-4 text-center" key={index}>
            <div className="service-item">
                <div className="glyph">
                    <Icofont icon={service.icon} />
                </div>
                <h3>{service.heading}</h3>
                <p>{service.description}</p>
            </div>
        </div>
    ));
    //Service loop END
    return (
        <React.Fragment>
            <section id="services" className="services ptb-100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 offset-lg-2 text-center">
                            <ScrollAnimation animateIn="fadeInUp">
                                <div className="section-title">
                                    <h2>{this.props.sectionTitle}</h2>
                                    <p>{this.props.sectionDescription}</p>
                                    <span className="section-title-bg">{this.props.SectionbgTitle}</span>
                                </div>
                            </ScrollAnimation>
                        </div>
                    </div>
                    <div className="row">
                        {servicedata}
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
  }
}

//Props Types
Services.propTypes = {
    SectionbgTitle: PropTypes.string,
    sectionTitle: PropTypes.string,
    sectionDescription: PropTypes.string,
    servicesData: PropTypes.array
};

//Default Props
Services.defaultProps = {
    SectionbgTitle: "Services",
    sectionTitle: "Services",
    sectionDescription:
        "Our team's diverse skillset allows us to tailor our services to match your needs across strategy, design, and development for mobile and web projects. From full-project engagements to à la carte services, we help our clients launch the best projects possible.",

    servicesData: [
        {
            icon: "icofont-iphone",
            heading: "Mobile App Development",
            description:
                "We take your idea from start to finish, creating a flushed-out and fluid mobile application for any platform."
        },
        {
            icon: "icofont-dashboard-web",
            heading: "Web App Development",
            description:
                "We take your business system and create custom web applications, ranging from web portals to dashboards or fully functioning, dynamic applications."
        },
        {
            icon: "icofont-laptop-alt",
            heading: "Website/Ecom Development",
            description:
                "Need a homepage for your company or an online store? We can help by creating or updating your site. From Shopify to Squarespace, we can manage any platform."
        },
        {
            icon: "icofont-chart-growth",
            heading: "SEO & Advertising",
            description:
                "Want your site to rank higher on search engines? We can boost your site to the top while also advertising your site across Facebook, Instagram and other networks."
        },
        {
            icon: "icofont-network-tower",
            heading: "Social Media Marketing & Consulting",
            description:
                "We can take your brand to the next level by offering above-the-line campaigns, 360 campaigns, and targeted social campaigns across any network."
        },
        {
            icon: "icofont-instagram",
            heading: "Instagram Account Growth",
            description:
                "Grow your profile and increase followers, likes, and comments organically."
        },
    ]
};

export default Services;
